import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { RefuelHistory, RefuelHistoryRequestParam, Vehicle } from 'types';
import DEFAULT_OPTION from 'domains/api/default_option';

type RefuelHistoriesResponse = {
  refuel_histories: RefuelHistory[];
};
type RefuelHistoryResponse = {
  refuel_history: RefuelHistory;
};
type EmptyResponse = Record<string, never>;

export const getRefuelHistories = async (
  vehicleId: number,
): Promise<RefuelHistoriesResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get(
    `fuel_consumption/vehicles/${vehicleId}/refuel_histories`,
    options,
  );

  return response.json();
};

export const getRefuelHistory = async (
  vehicleId: number,
  historyId: number,
): Promise<RefuelHistoryResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get(
    `fuel_consumption/vehicles/${vehicleId}/refuel_histories/${historyId}`,
    options,
  );

  return response.json();
};

export const postRefuelHistories = async (
  vehicle: Vehicle,
  history: RefuelHistoryRequestParam,
): Promise<RefuelHistoryResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { refuel_history: history },
    throwHttpErrors: true,
  };

  const response = await ky.post(
    `fuel_consumption/vehicles/${vehicle.id}/refuel_histories`,
    options,
  );

  return response.json();
};

export const patchRefuelHistory = async (
  vehicle: Vehicle,
  history: RefuelHistoryRequestParam,
): Promise<RefuelHistoryResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { refuel_history: history },
    throwHttpErrors: true,
  };

  const response = await ky.patch(
    `fuel_consumption/vehicles/${vehicle.id}/refuel_histories/${history.id}`,
    options,
  );

  return response.json();
};

export const deleteRefuelHistory = async (
  vehicle: Vehicle,
  history: RefuelHistory,
): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(
    `fuel_consumption/vehicles/${vehicle.id}/refuel_histories/${history.id}`,
    options,
  );

  return response.json();
};
